export const language: any = {
  LabelFavorites: "Favorit",
  LabelYouDontHaveRecipeAddYourFavoriteRecipe: `Belum ada resep favorit.<br/>Tambahkan resep yang Anda suka!`,
  LabelDoYouWantUnSave: `Apakah Anda ingin membatalkan penyimpanan resep ini?`,
  save: "Simpan",
  unsave: "Batalkan Simpan",
  OkFavorite: "Ya",
  CloseFavorite: "Tidak",
};
